import http from './httpService';
import * as models from '../utils/models';

const endpoint: string = '/division';

interface DivisionResponse {
	division: models.Division[];
}

const createDivision = (
	data: Omit<models.Division, '_id'>,
	onUploadProgress: models.ProgressChange
) => {
	const apiData = { ...data } as any;
	apiData.inspectionType = apiData.inspectionType.map(
		(t: models.SelectOption) => t.id
	);

	return http.post(`${endpoint}/new-division`, apiData, { onUploadProgress });
};

const getAllDivisions = () => {
	return http.get<DivisionResponse>(endpoint);
};

const getOneDivision = (divisionId: string) => {
	return http.get<{ division: models.Division; }>(`${endpoint}/${divisionId}`);
};

const updateDivision = (
	divisionId: string,
	data: Omit<models.Division, '_id'>,
	onUploadProgress: models.ProgressChange
) => {
	const apiData = { ...data } as any;
	apiData.inspectionType = apiData.inspectionType.map(
		(t: models.SelectOption) => t.id
	);

	return http.put(`${endpoint}/update-division/${divisionId}`, apiData, {
		onUploadProgress,
	});
};

export { createDivision, getAllDivisions, getOneDivision, updateDivision };
